<template>
  <div>
    <div v-if="status === 'Submitted'">
      <b-button variant="outline-primary" class="mr-3" @click="requestChanges">
        Request changes
      </b-button>

      <b-button ref="button__reviewer-approve-lu" variant="success" @click="approve">
        Approve for publication
      </b-button>
    </div>

    <!-- <b-dropdown
      v-if="status === 'Submitted'"
      right
      split
      text="Approve for publication"
      variant="success"
      @click="approve"
      ref="button__reviewer-approve-lu"
      class="button__reviewer-approve-lu button__status-dropdown"
    >
      <b-dropdown-item @click="revertToDraft">Revert to draft</b-dropdown-item>
    </b-dropdown> -->

    <b-dropdown
      v-if="status === 'Published'"
      ref="button__reviewer-edit-lu-status"
      right
      split
      text="Edit status"
      variant="outline-primary"
      class="button__reviewer-edit-lu-status button__status-dropdown"
      @click="editStatus"
    >
      <b-dropdown-item class="dropdown-item__request-changes" @click="requestChanges"
        >Request changes</b-dropdown-item
      >

      <b-dropdown-item class="dropdown-item__revert-to-draft" @click="revertToDraft"
        >Revert to draft</b-dropdown-item
      >

      <b-dropdown-item class="dropdown-item__revert-to-submitted" @click="revertToSubmitted"
        >Revert to submitted</b-dropdown-item
      >
    </b-dropdown>

    <comfirm-modal
      :show.sync="showModal"
      :type="typeModal"
      :learning-unit="learningUnit"
      @confirmed="confirmed"
    ></comfirm-modal>
  </div>
</template>

<script>
import LearningUnit from '@/models/LearningUnit';
import ComfirmModal from './ComfirmModal';
export default {
  components: {
    ComfirmModal
  },

  props: {
    learningUnit: {
      type: LearningUnit,
      required: true
    }
  },

  data() {
    return {
      showModal: false,
      typeModal: ''
    };
  },

  computed: {
    status() {
      let status = 'Draft';
      if (this.learningUnit.required_review) {
        status = 'Submitted';
      }
      if (this.learningUnit.is_published) {
        status = 'Published';
      }
      return status;
    }
  },

  methods: {
    approve() {
      this.typeModal = 'Approve';
      this.showModal = true;
    },

    editStatus() {
      console.log('Edit');
      // this.showModal = true;
    },

    requestChanges() {
      this.$router.push({
        name: 'review-learning-unit/request-changes',
        params: { learningUnitId: this.learningUnit.id }
      });
    },

    revertToDraft() {
      this.typeModal = 'Draft';
      this.showModal = true;
    },

    revertToSubmitted() {
      this.typeModal = 'Submitted';
      this.showModal = true;
    },

    confirmed() {
      this.showModal = false;

      this.$emit('confirmed');
    }
  }
};
</script>
